if (!window.__cardSlideshowInit) {
  window.__cardSlideshowInit = true;

  function initSlideshows() {
    document.querySelectorAll('.card__media--slideshow:not([data-slideshow-ready])').forEach((el) => {
      const images = el.querySelectorAll('.card-slideshow__img');
      if (images.length <= 1) return;

      el.setAttribute('data-slideshow-ready', '');
      let current = 0;

      setInterval(() => {
        images[current].classList.remove('is-active');
        current = (current + 1) % images.length;
        images[current].classList.add('is-active');
      }, 3000);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSlideshows);
  } else {
    initSlideshows();
  }
}
